<si-icon class="icon-lg" [class.badge-dot]="badgeDot()" [icon]="icon()" />
@if (badgeValue()) {
  <span class="badge-text">{{ badgeValue() }}</span>
}
<ng-content select="si-avatar" />
<div #itemTitle class="item-title" [class.visually-hidden]="visuallyHideTitle()">
  <ng-content />
</div>
@if (dropdownTrigger) {
  <si-icon class="dropdown-caret" [icon]="icons.elementDown2" />
}
